<template>
  <span>
    <extra-headers-component
      v-if="edit"
      :default-items="items"
      :show-items="true"
      :editing="true"
      :type="type"
      @done="itemsDone"
    ></extra-headers-component>


    <table v-else-if="items && defaultItems.length > 0" class="w-100 mt-4">
      <tbody>
      <tr
          class="border-bottom"
          v-for="(item, index) in defaultItems"
          :key="index"
      >
        <td class="pb-2 pt-2 font-weight-black">
          {{item.label}}
        </td>
        <td class="text-right">
          {{item.value}}
        </td>

      </tr>
      </tbody>
    </table>
     <div v-if="show_edit">
        <v-btn block x-small color="blue" rounded text @click="edit = true"
        >Change<v-icon x-small>mdi-pencil</v-icon></v-btn
        >
      </div>

    <v-snackbar v-model="success" color="green" dark>{{
      success_message
    }}</v-snackbar>
    <v-snackbar v-model="error" color="error" dark>{{
      error_message
    }}</v-snackbar>
  </span>
</template>

<script>
import ExtraHeadersComponent from "./extraHeadersComponent";

export default {
  components: { ExtraHeadersComponent },
  props: {
    headers: { type: Array, default: () => [] },
    footers: { type: Array, default: () => [] },
    documentType: { type: String, default: "invoice" },
    type: { type: String, default: "header" },
  },
  name: "headersView",
  data() {
    return {
      invoice_id: null,
      edit: false,
      defaultItems: [],
      show_edit: true,
      success: false,
      error: false,
      error_message: "",
      success_message: "",
    };
  },
  computed: {
    items() {
      return this.type === "footer" ? this.footers : this.headers;
    },
    apiEndpoint() {
      if (this.type === "footer") {
        return this.documentType === "quote"
          ? "/api/quote/footers/"
          : "/api/invoice/footers/";
      } else {
        return this.documentType === "quote"
          ? "/api/quote/headers/"
          : "/api/invoice/headers/";
      }
    },
    containerClass() {
      const base = "d-flex flex-column mt-2";
      const align =
        this.type === "header" ? "align-items-end" : "align-items-start";
      return `${base} ${align}`;
    },
  },
  methods: {
    itemsDone(event) {
      this.defaultItems = event.items;
      this.edit = false;
      this.updateItems();
    },
    updateItems() {
      const formData = new FormData();

      const dataKey = this.type === "footer" ? "new_footers" : "new_headers";
      formData.append(dataKey, JSON.stringify(this.defaultItems));

      axios
        .post(this.apiEndpoint + this.invoice_id, formData)
        .then((res) => {
          this.success_message = "Info updated successfully";
          this.success = true;
        })
        .catch((error) => {
          // this.error_message = "Something went wrong, could not update info.";
          // this.error = true;
        });
    },
  },
  mounted() {
    if (this.items.length) {
      if (this.documentType == "quote") {
        this.invoice_id = this.items[0].quote_id;
      } else {
        this.invoice_id = this.items[0].invoice_id;
      }

      this.defaultItems = this.items;
    } else {
      this.show_edit = false;
    }
  },
};
</script>

<style scoped></style>
